import {Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
import FTMTabs from './FTMTabs';

const {Paragraph} = Typography;
const Content = Layout;

const FTM = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3' style={{color: appColors['ColorX'], marginTop: '-10vh'}}>Fundamentals and troubleshooting</Paragraph>
      </Content>
      <FTMTabs/>
    </Layout>
  );
};

export default FTM;
